import { AppRouteProps } from "@harea/component";
import React from "react";
import { AboutUserDetailsRoutes } from "./views/about/AboutUserDetailsRoutes";
import { ParamsUserDetailsRoutes } from "./views/params/ParamsUserDetailsRoutes";
import { ContractUserDetailsRoutes } from "./views/contract/ContractUserDetailsRoutes";
import { AbsenceUserDetailsRoutes } from "./views/absence/AbsenceUserDetailsRoutes";
import { PayrollUserDetailsRoutes } from "./views/payroll/PayrollUserDetailsRoutes";
import { FamilyUserDetailsRoutes } from "./views/family/FamilyUserDetailsRoutes";
import { DocumentsUserDetailsRoutes } from "./views/documents/DocumentsUserDetailsRoutes";

const UserDetailsContainer = React.lazy(() => import('./containers/UserDetailsContainer'))
export const UserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'employees/:id',
        element: <UserDetailsContainer />,
        children: [
            ...AboutUserDetailsRoutes,
            ...ParamsUserDetailsRoutes,
            ...ContractUserDetailsRoutes,
            ...AbsenceUserDetailsRoutes,
            ...PayrollUserDetailsRoutes,
            ...FamilyUserDetailsRoutes,
            ...DocumentsUserDetailsRoutes,
        ]
    }
]